import { Flex, chakra } from '@chakra-ui/react';
import type { SettingsFormReturn } from '../useSettingsForm';

export function SaveCancelBar({ form }: { form: SettingsFormReturn }) {
  const { handleSaveChanges, handleCancel, isSaving } = form;
  return (
    <Flex
      position="fixed"
      bottom={{ base: 'var(--mobile-bottom-safe)', lg: '0' }}
      left={{ base: '0', lg: 'var(--sidebar-width)' }}
      right="0"
      bg="white"
      borderTopWidth="1px"
      borderColor="volyx.borderLight"
      p="4"
      pb={{ base: '4', lg: 'calc(1rem + env(safe-area-inset-bottom, 0px))' }}
      gap="3"
      borderRadius="0"
      flexDir={{ base: 'column', sm: 'row' }}
      justify={{ base: 'flex-start', sm: 'flex-end' }}
      zIndex={110}
      boxShadow="0 -4px 24px rgba(0,0,0,0.08)"
    >
      <chakra.button
        px="6"
        py="3"
        w={{ base: '100%', sm: 'auto' }}
        borderRadius="xl"
        fontWeight="semibold"
        transition="all 0.3s"
        cursor="pointer"
        border="none"
        bg="volyx.lightGray"
        color="volyx.text"
        _hover={{ bg: 'volyx.mediumGray', transform: 'scale(1.01)' }}
        _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
        onClick={handleCancel}
        disabled={isSaving}
      >
        Cancel
      </chakra.button>
      <chakra.button
        px="6"
        py="3"
        w={{ base: '100%', sm: 'auto' }}
        borderRadius="xl"
        fontWeight="semibold"
        transition="all 0.3s"
        cursor="pointer"
        border="none"
        bg="volyx.action"
        color="white"
        _hover={{ bg: 'rgba(0,122,255,0.9)', boxShadow: '0 8px 24px rgba(0,0,0,0.12)', transform: 'translateY(-2px) scale(1.02)' }}
        _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
        onClick={handleSaveChanges}
        disabled={isSaving}
      >
        {isSaving ? 'Saving...' : 'Save Changes'}
      </chakra.button>
    </Flex>
  );
}
